export default __webpack_public_path__ + "static/warehouse-rentals-balthazaurus-scroll-a76a768561977a0af60e7a28d3d475d2.gif";